import {createSlice} from '@reduxjs/toolkit';
import {loadBuildingResources} from './actions';
import {BuildingResourcesEntity} from '..';

const initialState: {resourcesByBuildingId: Record<string, BuildingResourcesEntity | undefined>} = {
  resourcesByBuildingId: {},
};

const slice = createSlice({
  name: 'buildingResources',
  initialState,

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadBuildingResources.pending, (state, action) => {
        const buildingId = action.meta.arg;
        const previousEntry = state.resourcesByBuildingId[buildingId];

        state.resourcesByBuildingId[buildingId] = {
          status: 'loading',
          buildingId,
          // Keep previously loaded resources when we refresh
          resources: previousEntry?.resources,
          floordIds: previousEntry?.floordIds,

          // Keep previous error message while we refresh
          errorMessage: previousEntry?.errorMessage,
        };
      })
      .addCase(loadBuildingResources.fulfilled, (state, action) => {
        const buildingId = action.meta.arg;

        state.resourcesByBuildingId[buildingId] = {
          status: 'loaded',
          buildingId,
          // Keep previously loaded resources when we refresh
          resources: action.payload.resources,
          floordIds: action.payload.floordIds,

          // Clear error message on successful load
          errorMessage: undefined,
        };
      })
      .addCase(loadBuildingResources.rejected, (state, action) => {
        const buildingId = action.meta.arg;
        const previousEntry = state.resourcesByBuildingId[buildingId];

        state.resourcesByBuildingId[buildingId] = {
          status: 'failed',
          buildingId,
          // Keep previously loaded resources in case we still want to show those
          resources: previousEntry?.resources,
          floordIds: previousEntry?.floordIds,

          // Clear error message on successful load
          errorMessage: action.error.message ?? `Failed to load building resources`,
        };
      });
  },
});

export const {reducer: buildingResourcesReducer} = slice;
